/*
 * Disaster Tees — drop countdown.
 *
 * Ticks once a second against an absolute instant. The target carries its own
 * UTC offset so every visitor counts down to the same moment rather than to
 * 10am in whatever zone their laptop is set to.
 */
class DTCountdown extends HTMLElement {
  connectedCallback() {
    const raw = this.dataset.target;
    this.target = raw ? Date.parse(raw) : NaN;

    this.units = this.querySelector('[ref="units"]');
    this.expired = this.querySelector('[ref="expired"]');
    this.fields = {
      days: this.querySelector('[ref="days"]'),
      hours: this.querySelector('[ref="hours"]'),
      minutes: this.querySelector('[ref="minutes"]'),
      seconds: this.querySelector('[ref="seconds"]'),
    };

    if (Number.isNaN(this.target)) {
      this.#showExpired();
      return;
    }

    this.#tick();
    this.timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  #showExpired() {
    clearInterval(this.timer);
    if (this.units) this.units.hidden = true;
    if (this.expired) this.expired.hidden = false;
  }

  #tick() {
    const remaining = this.target - Date.now();

    if (remaining <= 0) {
      this.#showExpired();
      return;
    }

    const seconds = Math.floor(remaining / 1000);
    const pad = (n) => String(n).padStart(2, '0');

    this.#set('days', String(Math.floor(seconds / 86400)));
    this.#set('hours', pad(Math.floor(seconds / 3600) % 24));
    this.#set('minutes', pad(Math.floor(seconds / 60) % 60));
    this.#set('seconds', pad(seconds % 60));
  }

  #set(name, value) {
    const el = this.fields[name];
    if (el && el.textContent !== value) el.textContent = value;
  }
}

if (!customElements.get('dt-countdown')) customElements.define('dt-countdown', DTCountdown);
